module.exports = __webpack_public_path__ + "static/media/headerLogo.3549c30b.png";